import {getValueWrapper} from "./utils.js";

/**
 *
 * @param item
 * @param {{
 *   AggregateMethod: string,
 *   ExpandProductionRow: string,
 *   PSISortOrder: string,
 * }} options
 * @returns {*[]}
 */
export function createPSITableRows(item, options) {
  if (options.ExpandProductionRow === "expand") return createPSITableRowsWithExpandedProductionRow(item, options);
  return createPSITableRowsWithCollapsedProductionRow(item, options);
}

function createPSITableRowsWithCollapsedProductionRow(item, options) {
  const salesRow = {
    Title: "S: 受注",
    itemCode: item.itemCode,
    cellBackgroundColor: "#FFF4F8",
    cellTextColor: "#757575",
    subRowPosition: {
      index: 0,
      total: 4,
      isFirstRow: true,
      isLastRow: false,
    },
    getValue: (itemData, dateString) => getValueWrapper(() => itemData.demand[dateString], 0)
  }
  const productionRow = {
    Title: "P: 生産",
    itemCode: item.itemCode,
    subRowPosition: {
      index: 1,
      total: 4,
      isFirstRow: false,
      isLastRow: false,
    },
    getValue: (itemData, dateString) => getValueWrapper(() => {
      const productionData = itemData.production[dateString];

      // Check if productionData is an object with multiple production lines (like {2号: 120, 1号: 130})
      if (productionData && typeof productionData === 'object') {
        // Sum all the values in the productionData object
        return Object.values(productionData).reduce((sum, value) => sum + value, 0);
      }

      // Return 0 if there's no production data for the date
      return 0;
    }, 0)
  }
  const inventoryRow = {
    Title: "I: 在庫",
    itemCode: item.itemCode,
    cellBackgroundColor: "#EAFFF0",
    cellTextColor: (_, __, cellValue) => {
      if (cellValue <= 0) return "red"
      return "black"
    },
    cellTextWeight: (_, __, cellValue) => {
      if (cellValue <= 0) return "bold"
      return "normal"
    },
    lineColor: "#07C093",
    subRowPosition: {
      index: 2,
      total: 4,
      isFirstRow: false,
      isLastRow: true,
    },
    getValue: (itemData, dateString) => getValueWrapper(() => itemData.inventory[dateString], 0)
  }
  const aggregationRow = {
    Title: "在庫日数",
    itemCode: item.itemCode,
    cellBackgroundColor: "#EAFFF0",
    cellTextColor: "#757575",
    subRowPosition: {
      index: 2 + item.resources.length,
      total: 3 + item.resources.length,
      isFirstRow: false,
      isLastRow: true,
    },
    getValue: (itemData, dateString) => {
      const val = getValueWrapper(() => itemData.computed[options.AggregateMethod][dateString], null)
      if (typeof val !== "number") return "--"
      return Math.round(val * 10) / 10
    }
  }
  return options.PSISortOrder === "psi"
    ? [productionRow, salesRow, inventoryRow, aggregationRow]
    : [salesRow, productionRow, inventoryRow, aggregationRow]
}

function createPSITableRowsWithExpandedProductionRow(item, options) {
  const salesRow = {
    Title: "S: 受注",
    itemCode: item.itemCode,
    cellBackgroundColor: "#FFF4F8",
    cellTextColor: "#757575",
    subRowPosition: {
      index: 0,
      total: 3 + item.resources.length,
      isFirstRow: true,
      isLastRow: false,
    },
    getValue: (itemData, dateString) => getValueWrapper(() => itemData.demand[dateString], 0)
  }
  const productionRows = item.resources
    .toSorted()
    .map((resource, index) => ({
      Title: resource,
      itemCode: item.itemCode,
      subRowPosition: {
        index: 1 + index,
        total: 3 + item.resources.length,
        isFirstRow: false,
        isLastRow: false,
      },
      getValue: (itemData, dateString) => getValueWrapper(() => itemData.production[dateString][resource], 0),
    }))
  const inventoryRow = {
    Title: "I: 在庫",
    itemCode: item.itemCode,
    cellBackgroundColor: "#EAFFF0",
    cellTextColor: (_, __, cellValue) => {
      if (cellValue <= 0) return "red"
      return "#757575"
    },
    cellTextWeight: (_, __, cellValue) => {
      if (cellValue <= 0) return "bold"
      return "normal"
    },
    subRowPosition: {
      index: 1 + item.resources.length,
      total: 3 + item.resources.length,
      isFirstRow: false,
      isLastRow: false,
    },
    getValue: (itemData, dateString) => getValueWrapper(() => itemData.inventory[dateString], 0)
  }
  const aggregationRow = {
    Title: "在庫日数",
    itemCode: item.itemCode,
    cellBackgroundColor: "#EAFFF0",
    cellTextColor: "#757575",
    subRowPosition: {
      index: 2 + item.resources.length,
      total: 3 + item.resources.length,
      isFirstRow: false,
      isLastRow: true,
    },
    getValue: (itemData, dateString) => {
      const val = getValueWrapper(() => itemData.computed[options.AggregateMethod][dateString], null)
      if (typeof val !== "number") return "--"
      return Math.round(val * 10) / 10
    }
  }

  return options.PSISortOrder === "psi"
    ? [...productionRows, salesRow, inventoryRow, aggregationRow]
    : [salesRow, ...productionRows, inventoryRow, aggregationRow]
}